import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { CommonService } from '../../services/common/common.service';
import { ApiUrlHelper } from '../../common/api-url-helper';
import { StorageService } from '../../services/storage/storage.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { marked } from 'marked'; // Import `marked.js`
import { CdkDragEnd } from '@angular/cdk/drag-drop';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationModalComponent } from '../confirmation-modal/confirmation-modal.component';

@Component({
  selector: 'app-chat-gpt',
  templateUrl: './chat-gpt.component.html',
  styleUrls: ['./chat-gpt.component.scss'],
})
export class ChatGptComponent implements OnInit {
  userInput: string = '';
  response: string = '';
  isChatOpen: boolean = false; // Variable to track chat visibility
  userId: any;
  chat: any = [];
  CreateNewSession: boolean = false;
  chatForm: FormGroup;
  userImage!: string;
  formattedResponse: any;
  dragPosition = { x: 20, y: 100 };

  @ViewChild('chatBoxInner', { static: false }) chatBoxInner!: ElementRef;

  constructor(
    private readonly commonService: CommonService,
    private readonly storageService: StorageService,
    private readonly api: ApiUrlHelper,
    private readonly fb: FormBuilder,
    private readonly spinner: NgxSpinnerService,
    private readonly sanitizer: DomSanitizer,
    private readonly modalService: NgbModal,
  ) {
    this.chatForm = this.fb.group({
      userInput: ['', Validators.required],
    });
  }

  ngOnInit(): void {
    let decryptUserId = this.storageService.getValue('userId');
    this.userId = this.commonService.Decrypt(decryptUserId);
    this.userImage = this.storageService.getValue('userImage');
    this.commonService.getUserImage().subscribe(image => {
      if (image == '') {
        this.userImage = this.storageService.getValue('userImage') ? this.storageService.getValue('userImage') : '';
      }
      else {
        this.userImage =  image || '';
        localStorage.setItem('userImage', this.userImage);
      }
    });
  }

  ngAfterViewChecked() {
    this.scrollToBottom(); // Ensure it scrolls after the view is updated
  }

  sendMessage() {
    let api = this.api.apiUrl.AI.ChatGPTCreateAPI;
    this.chat.push({
      role: 'user',
      content: this.userInput.trim(),
    }, {
      role: 'assistance',
      content: "Processing..",
    })
    this.originalConent.push({
      role: 'user',
      content: this.userInput.trim(),
    })
    let requestedModel = {
      sessionId: this.userId,
      createNewSession: this.CreateNewSession,
      messages:
        this.originalConent,
    };

    this.commonService.doPost(api, requestedModel).subscribe({
      next: (res) => {
        if (res.success) {
          console.log(res);

          this.CreateNewSession = false;
          this.originalConent.push(res.data);
          this.chat =  this.originalConent.map((item: any) => ({
            ...item,
            content: this.getFormattedResponse(item.content), // Format each response
          }));
        }
        this.userInput = '';
      },
      error: (err) => {
        if (err.status === 429) {
          this.response =
            'You have exceeded your quota. Please try again later or upgrade your plan.';
        } else {
          this.response = 'An error occurred while fetching the response.';
        }
      },
    });
    this.userInput = '';
    this.chatForm.reset();
  }
  originalConent:any = [];
  getChatHistory() {
    let api = this.api.apiUrl.AI.GetChatHistory.replace(
      '{sessionId}',
      this.userId
    );
    this.commonService.doGet(api).subscribe({
      next: (res) => {
        if (res.success) {
          this.originalConent  =res.data;
          this.chat = res.data.map((item: any) => ({
            ...item,
            content: this.getFormattedResponse(item.content), // Format each response
          }));

          if (this.chat.length === 0) {
            this.chat = [
              {
                role: 'assistance',
                content: this.getFormattedResponse(
                  "Hello! It's nice to meet you. Is there something I can help you with, or would you like to chat?"
                ),
              },
            ];
          }
        }
      },
      error: (err) => {
        this.response =
          err.status === 429
            ? 'You have exceeded your quota. Please try again later or upgrade your plan.'
            : 'An error occurred while fetching the response.';
      },
    });
  }

  createNewSession() {
    this.chat = [];
    this.originalConent = [];
    this.CreateNewSession = true;
  }
  // Method to toggle chat visibility
  toggleChat() {
    this.isChatOpen = !this.isChatOpen;
    this.response = '';
  }

  scrollToBottom() {
    if (this.chatBoxInner) {
      this.chatBoxInner.nativeElement.scrollTop =
        this.chatBoxInner.nativeElement.scrollHeight;
    }
  }

  getFormattedResponse(rawResponse: string): SafeHtml {
    if (!rawResponse) return '';

    // Convert Markdown to HTML using `marked`
    const html = marked(rawResponse, { async: false });

    // Sanitize HTML before displaying it
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }
  updateChatButtonPosition(): void {
    const chatContainer = document.querySelector(
      '.draggable-container'
    ) as HTMLElement;
    if (chatContainer) {
      chatContainer.style.left = `${this.dragPosition.x}px`;
      chatContainer.style.top = `${this.dragPosition.y}px`;
    }
  }

  onDragEnd(event: CdkDragEnd | any): void {
    const { x, y } = event.source.getFreeDragPosition();
    this.dragPosition = { x, y };
    localStorage.setItem('dragPosition', JSON.stringify(this.dragPosition));
  }
  @ViewChild('content') content: any;

  createNewChat(){
    const modalRef = this.modalService.open(
      ConfirmationModalComponent,
      {
        backdrop: 'static',
       centered:true
      }
    );
    modalRef.componentInstance.title = 'Confirm';
    modalRef.componentInstance.message =
      'Are you sure you want create new chat?';
    modalRef.result.then((res: string) => {
      if (res === 'confirm') {
        this.createNewSession();
      }
    });
  }
  handleImageError() {
    this.userImage = '../../../assets/img/default-user-profile.svg';
  }
}
